import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';import {
  HorizonWrapper,
} from '../../components/common/Container';
import {
  CommonContainer,
} from '../../components/common/Container';
import PrintListContainer from '../../containers/member/PrintListContainer';

const PrintPage = () => {
    
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <HorizonWrapper>
          <CommonContainer>
            <PrintListContainer />
          </CommonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default PrintPage;
